import { createAction, props } from '@ngrx/store'
import { RequestModel, ReportSettingsModel, RatingPerLocationModel, ReviewCountPerLocationModel, FeedbackCountPerLocationModel, SendEngineEfficiencyPerLocationModel, AvergeContactSpeedPerLocationModel, FeedbackReviewPercentagePerLocationModel, StarsDistributionPerLocationModel, ReviewPerReviewSitePerLocationModel, SentimentCheckCountPerLocationModel, CampaignMetricsPerLocationModel, ClickedOnReviewPerLocationModel, GeneratedReportsModel, ScheduledReportModel } from '@models/index'
import { RatingPerReviewSitePerLocationModel } from '@models/ratingPerReviewSitePerLocation.model'
import { SentReviewRequestCountPerLocationModel } from '@models/sentReviewRequestCountPerLocation.model'

export const getReportsSettingsByBusiness = createAction(
    '[Reports Page] Get Reports Settings By Business',
    props<{ request: RequestModel }>()
)

export const getReportsSettingsByBusinessSuccess = createAction(
    '[Reports Page] Get Reports Settings By Business Success',
    props<{ reportsSettings: ReportSettingsModel }>()
)

export const saveReportsSettingsByBusiness = createAction(
    '[Reports Page] Save Reports Settings By Business',
    props<{ request: RequestModel }>()
)

export const generateReport = createAction(
    '[Reports Page] Generate Report',
    props<{ request: RequestModel }>()
)
export const generateReportSuccess = createAction(
    '[Reports Page] Generate Report Success',
    props<{ generatedReport: GeneratedReportsModel }>()
)

export const saveReportsSettingsByBusinessSuccess = createAction(
    '[Reports Page] Save Reports Settings By Business Success',
    props<{ reportsSettings: ReportSettingsModel }>()
)

export const getRatingPerLocation = createAction(
    '[Reports Page] Get Rating Per Location',
    props<{ startDate: number, endDate: number }>()
)

export const getRatingPerLocationSuccess = createAction(
    '[Reports Page] Get Rating Per LocationSuccess',
    props<{ ratingPerLocation: RatingPerLocationModel[] }>()
)

export const getStarsCountPerLocation = createAction(
    '[Reports Page] Get Stars Count Per Location',
    props<{ startDate: number, endDate: number }>()
)

export const getStarsCountPerLocationSuccess = createAction(
    '[Reports Page] Get Stars Count Per LocationSuccess',
    props<{ starsCountPerLocation: StarsDistributionPerLocationModel[] }>()
)

export const getReviewsPerLocation = createAction(
    '[Reports Page] Get Reviews Per Location',
    props<{ startDate: number, endDate: number }>()
)

export const getReviewsPerLocationSuccess = createAction(
    '[Reports Page] Get Reviews Per LocationSuccess',
    props<{ reviewsPerLocation: ReviewCountPerLocationModel[] }>()
)

export const getFeedbacksPerLocation = createAction(
    '[Reports Page] Get Feedbacks Per Location',
    props<{ startDate: number, endDate: number }>()
)

export const getFeedbacksPerLocationSuccess = createAction(
    '[Reports Page] Get Feedbacks Per LocationSuccess',
    props<{ feedbacksPerLocation: FeedbackCountPerLocationModel[] }>()
)

export const getClickedOnReviewPerLocation = createAction(
    '[Reports Page] Get Clicked On Review Per Location',
    props<{ startDate: number, endDate: number }>()
)

export const getClickedOnReviewPerLocationSuccess = createAction(
    '[Reports Page] Get Clicked On Review Per LocationSuccess',
    props<{ clickedOnReviewPerLocation: ClickedOnReviewPerLocationModel[] }>()
)

export const getSendEngineEfficiencyPerLocation = createAction(
    '[Reports Page] Get Send Engine Efficiency Per Location',
    props<{ startDate: number, endDate: number }>()
)

export const getSendEngineEfficiencyPerLocationSuccess = createAction(
    '[Reports Page] Get Send Engine Efficiency Per LocationSuccess',
    props<{ senEngineEfficiencyPerLocation: SendEngineEfficiencyPerLocationModel[] }>()
)

export const getAverageContactSpeedPerLocation = createAction(
    '[Reports Page] Get Average Contact Speed Per Location',
    props<{ startDate: number, endDate: number }>()
)

export const getAverageContactSpeedPerLocationSuccess = createAction(
    '[Reports Page] Get Average Contact Speed LocationSuccess',
    props<{ averageContactSpeedPerLocation: AvergeContactSpeedPerLocationModel[] }>()
)

export const getFeedbackReviewPercentagePerLocation = createAction(
    '[Reports Page] Get Feedback Review Percentage Per Location',
    props<{ request: RequestModel }>()
)

export const getFeedbackReviewPercentagePerLocationSuccess = createAction(
    '[Reports Page] Get Feedback Review Percentage Per Location Success',
    props<{ feedbackReviewPercentage: FeedbackReviewPercentagePerLocationModel[] }>()
)

export const getReviewPerReviewSitePerLocation = createAction(
    '[Reports Page] Get Review Per Review Site Per Location',
    props<{ startDate: number, endDate: number }>()
)

export const getReviewPerReviewSitePerLocationSuccess = createAction(
    '[Reports Page] Get Review Per Review Site Per Location Success',
    props<{ reviewsPerReviewSite: ReviewPerReviewSitePerLocationModel[] }>()
)

export const getRatingPerReviewSitePerLocation = createAction(
    '[Reports Page] Get Rating Per Review Site Per Location',
    props<{ startDate: number, endDate: number }>()
)

export const getRatingPerReviewSitePerLocationSuccess = createAction(
    '[Reports Page] Get Rating Per Review Site Per LocationSuccess',
    props<{ ratingPerReviewSite: RatingPerReviewSitePerLocationModel[] }>()
)

export const getSentRequestCountPerLocation = createAction(
    '[Reports Page] Get Sent Request Count Per Location',
    props<{ startDate: number, endDate: number }>()
)

export const getSentRequestCountPerLocationSuccess = createAction(
    '[Reports Page] Get Sent Request Count Per Location Success',
    props<{ sentRequestCount: SentReviewRequestCountPerLocationModel[] }>()
)

export const getSentimentCheckCountPerLocation = createAction(
    '[Reports Page] Get Sentiment Check Count Count Per Location',
    props<{ startDate: number, endDate: number }>()
)

export const getSentimentCheckCountPerLocationSuccess = createAction(
    '[Reports Page] Get Sentiment Check Count Count Per Location Success',
    props<{ sentimentCheckCount: SentimentCheckCountPerLocationModel[] }>()
)

export const getCampaignMetricsPerLocation = createAction(
    '[Reports Page] Get Campaign Metrics Per Location',
    props<{ startDate: number, endDate: number }>()
)

export const getCampaignMetricsPerLocationSuccess = createAction(
    '[Reports Page] Get Campaign Metrics Per Location Success',
    props<{ campaignMetrics: CampaignMetricsPerLocationModel[] }>()
)

export const setGeneralReportDateRange = createAction(
    '[Reports Page] Set General Report Date Range',
    props<{ payload: {startTime: number, endTime: number} }>()
)

export const sendTest = createAction(
    '[Reports Page] Send Test',
    props<{ request: RequestModel }>()
)

export const sendEmailTestSuccess = createAction(
    '[Reports Page] Send Test Success',
    props<{ sendTest: any }>()
)

export const searchGeneratedReports = createAction(
    '[Reports Page] Search Generated Reports',
    props<{ pages: { page: number, size: number, businessId: string } }>()
)

export const deleteGeneratedReport = createAction(
    '[Reports Page] Delete Generated Report',
    props<{ request: RequestModel }>()
)

export const deleteGeneratedReportSuccess = createAction(
    '[Reports Page] Delete Generated Report Success',
    props<{ deletedReportId: {data: string} }>()
)

export const searchGeneratedReportsSuccess = createAction(
    '[Reports Page] Search Generated Reports Success',
    props<{ total: number, data: GeneratedReportsModel[] }>()
)

export const clearReportSettings = createAction(
    '[Reports Page] Clear Report Settings'
)

export const searchScheduledReportsPerBusiness = createAction(
    '[Reports Page] Search Scheduled Reports Per Business',
    props<{ request: RequestModel }>()
)

export const searchScheduledReportsPerBusinessSuccess = createAction(
    '[Reports Page] Search Scheduled Reports Per Business Success',
    props<{ scheduledReports: ScheduledReportModel[] }>()
)

export const addScheduledReportToBusiness = createAction(
    '[Reports Page] Add Scheduled Report To Business',
    props<{ request: RequestModel }>()
)

export const addScheduledReportToBusinessSuccess = createAction(
    '[Reports Page] Add Scheduled Report To Business Success',
    props<{ scheduledReport: ScheduledReportModel }>()
)

export const editScheduledReport = createAction(
    '[Reports Page] Edit Scheduled Report',
    props<{ request: RequestModel }>()
)

export const editScheduledReportSuccess = createAction(
    '[Reports Page] Edit Scheduled Report Success',
    props<{ scheduledReport: ScheduledReportModel }>()
)

export const deleteScheduledReport = createAction(
    '[Reports Page] Delete Scheduled Report',
    props<{ request: RequestModel }>()
)

export const deleteScheduledReportSuccess = createAction(
    '[Reports Page] Delete Scheduled Report Success',
    props<{ id: {data: string}}>()
)

export const reportsError = createAction(
    '[Reports Page] Reports Error',    
    props<{ error: string }>()
)

export const getClickedOnReviewForLocationCampaign = createAction(
    '[Reports Page] Get Clicked On Review Per Location Campaign',
    props<{ startDate: number, endDate: number, campaignId: string, locationId: string }>()
)

export const getClickedOnReviewForLocationCampaignSuccess = createAction(
    '[Reports Page] Get Clicked On Review Per Location Campaign Success',
    props<{ clickedOnReviewPerLocation: ClickedOnReviewPerLocationModel[] }>()
)

export const getSendEngineEfficiencyForLocationCampaign = createAction(
    '[Reports Page] Get Send Engine Efficiency For Location Campaign',
    props<{ startDate: number, endDate: number, campaignId: string, locationId: string }>()
)

export const getSendEngineEfficiencyForLocationCampaignSuccess = createAction(
    '[Reports Page] Get Send Engine Efficiency For Location Campaign Success',
    props<{ clickedOnReviewPerLocation: ClickedOnReviewPerLocationModel[] }>()
)

export const getSentRequestCountForLocationCampaign = createAction(
    '[Reports Page] Get Sent Request Count Per Location Campaign',
    props<{ startDate: number, endDate: number, campaignId: string, locationId: string }>()
)

export const getSentRequestCountForLocationCampaignSuccess = createAction(
    '[Reports Page] Get Sent Request Count Per Location Campaign Success',
    props<{ sentRequestCount: SentReviewRequestCountPerLocationModel[] }>()
)

export const getSentimentCheckCountForLocationCampaign = createAction(
    '[Reports Page] Get Sentiment Check Count Count Per Location Campaign',
    props<{ request: RequestModel }>()
)

export const getSentimentCheckCountForLocationCampaignSuccess = createAction(
    '[Reports Page] Get Sentiment Check Count Count Per Location Campaign Success',
    props<{ sentimentCheckCount: SentimentCheckCountPerLocationModel[] }>()
)

export const getCampaignMetricsForLocationCampaign = createAction(
    '[Reports Page] Get Campaign Metrics Per Location Campaign',
    props<{ startDate: number, endDate: number, campaignId: string, locationId: string }>()
)

export const getCampaignMetricsForLocationCampaignSuccess = createAction(
    '[Reports Page] Get Campaign Metrics Per Location Campaign Success',
    props<{ campaignMetrics: CampaignMetricsPerLocationModel[] }>()
)
export const getFeedbacksPerLocationCampaign = createAction(
    '[Reports Page] Get Feedback Review Percentage Per Location Campaign',
    props<{ startDate: number, endDate: number, campaignId: string, locationId: string }>()
)
